import React from 'react';
import { Brain, Play } from 'lucide-react';

export function Header() {
  return (
    <header className="sticky top-0 z-40 border-b border-[#e8e4dc] bg-[#fbfaf7]/90 backdrop-blur-xl">
      <div className="mx-auto max-w-[1200px] px-5 py-4 sm:px-8">
        <div className="flex items-center justify-between">
          {/* Logo - Minimal */}
          <a href="/" className="group flex items-center gap-3 text-slate-950 transition-opacity hover:opacity-75">
            <span className="relative grid h-10 w-10 place-items-center rounded-[14px] bg-[#6d4aff] text-white shadow-[0_8px_24px_-10px_rgba(109,74,255,.8)]">
              <Brain className="h-[22px] w-[22px]" strokeWidth={2.2} />
              <span className="absolute -bottom-1 -right-1 grid h-4 w-4 place-items-center rounded-full border-2 border-[#fbfaf7] bg-[#17141f]"><Play className="ml-px h-2 w-2 fill-white text-white" /></span>
            </span>
            <span><span className="block text-[17px] font-extrabold tracking-[-.035em]">튜브브레인</span><span className="block text-[9px] font-bold tracking-[.22em] text-slate-400">TUBEBRAIN</span></span>
          </a>

          {/* Nav - Simple */}
          <nav className="flex items-center gap-6">
            <a href="#features" className="hidden text-sm font-semibold text-slate-500 hover:text-slate-950 sm:block">어떻게 도와주나요?</a>
            <a href="#start" className="rounded-full bg-[#17141f] px-5 py-2.5 text-sm font-bold text-white transition hover:bg-[#6d4aff]">영상 넣기</a>
          </nav>
        </div>
      </div>
    </header>
  );
}
